import React from "react";
import {
  Dumbbell,
  UtensilsCrossed,
  Calculator,
  Scale,
  Hotel,
  Cpu,
  Sparkles,
} from "lucide-react";

const SECTORS = [
  { icon: Dumbbell, label: "Fitness" },
  { icon: UtensilsCrossed, label: "Hospitality" },
  { icon: Calculator, label: "Accounting" },
  { icon: Scale, label: "Legal" },
  { icon: Hotel, label: "Hotels" },
  { icon: Cpu, label: "SaaS" },
  { icon: Sparkles, label: "AI Products" },
];

export default function TrustedBy() {
  return (
    <section
      data-testid="trusted-by-section"
      className="relative border-y border-white/[0.06] bg-[#06101D]/40 py-9 md:py-10 overflow-hidden"
      aria-label="Sectors we work across"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="shrink-0 flex items-center gap-3">
            <span className="h-px w-8 bg-gradient-to-r from-transparent to-[#00D4FF]/50" aria-hidden />
            <span className="text-[10.5px] uppercase tracking-[0.24em] text-slate-400 font-medium whitespace-nowrap">
              Trusted across
            </span>
          </div>

          <div className="relative flex-1 min-w-0">
            {/* Edge fade masks (mobile scroll only) */}
            <div className="md:hidden pointer-events-none absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-[#07111F] to-transparent z-10" aria-hidden />
            <div className="md:hidden pointer-events-none absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-[#07111F] to-transparent z-10" aria-hidden />

            <div
              className="flex items-center gap-7 md:gap-10 overflow-x-auto md:overflow-visible md:flex-wrap md:justify-between scrollbar-hide"
              style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
            >
              {SECTORS.map((s, i) => {
                const Icon = s.icon;
                return (
                  <div
                    key={s.label}
                    data-testid={`trusted-sector-${i}`}
                    className="mk-reveal group flex items-center gap-2.5 text-slate-400 hover:text-white transition-colors duration-300 shrink-0"
                    style={{ transitionDelay: `${i * 50}ms` }}
                    title={`${s.label} sector`}
                  >
                    <Icon className="h-4 w-4 text-slate-500 group-hover:text-[#00D4FF] transition-colors duration-300" />
                    <span className="text-[13.5px] font-medium tracking-tight whitespace-nowrap">
                      {s.label}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
